module.exports = __webpack_public_path__ + "assets/images/night-computer-hdd-hard-drive.webp";